import { inject, singleton } from "tsyringe";
import { COOKIES } from "@identity/symbols";
import { QueryString } from "./query-string";

@singleton()
export class ExperimentBucketing {
  constructor(
    @inject(COOKIES) private readonly cookiesManager: CookiesManager,
  ) {}

  getForcedBucket(): string | null {
    return QueryString.get("pf_pathfinder_force_bucket");
  }

  getWikiaBucket(): string | undefined {
    const cookie = this.cookiesManager.get("exp_bucket");
    const newCookieFormatRegex = /^(?:v\d-)?(\d{2})/;

    if (cookie) {
      if (newCookieFormatRegex.test(cookie)) {
        return cookie;
      } else {
        return "vN-" + cookie;
      }
    }
  }

  getCurrentBucket(): string {
    const forcedBucket = this.getForcedBucket();

    const bucket = forcedBucket ?? this.getWikiaBucket() ?? "v5-100";

    const bucketValue = bucket.split("-").pop() ?? "";

    return bucketValue.padStart(2, "0");
  }
}
